import { CatalogFilterMode } from '../models/catalog-scope.enum';

export const SCOPE_FILTER_OPTIONS: { label: string, value: CatalogFilterMode }[] = [
  { label: 'All Items', value: CatalogFilterMode.AllItems },
  { label: 'My Items', value: CatalogFilterMode.MyItems },
  { label: 'Global Items', value: CatalogFilterMode.GlobalItems }
];

export const SCOPE_OPTIONS: { label: string, value: number }[] = [
  { label: 'User', value: 0 },
  { label: 'Global', value: 1 }
];
